const SAFETY_TIMEOUT_MS = 8000;

function dismissLoader(): void {
    const loader = document.getElementById('app-loader');
    if (loader === null || loader.classList.contains('app-loader--hidden')) {
        return;
    }

    loader.classList.add('app-loader--hidden');
    loader.addEventListener('transitionend', () => loader.remove(), { once: true });
}

// Called by Blazor via IJSRuntime in Routes.razor OnAfterRenderAsync,
(window as any).AppLoader = { dismiss: dismissLoader };

// Safety net: if the Blazor circuit never connects (e.g. SignalR failure) the loader would stay on screen forever. After the timeout, dismiss.
window.setTimeout(() => {
    if (document.getElementById('app-loader') === null) {
        return;
    }

    dismissLoader();
}, SAFETY_TIMEOUT_MS);
